import { render, staticRenderFns } from "./AssignWorkPeriodFormTemplate.vue?vue&type=template&id=298a8a7f&scoped=true&"
import script from "./AssignWorkPeriodFormTemplate.vue?vue&type=script&lang=ts&"
export * from "./AssignWorkPeriodFormTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298a8a7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VContainer,VForm})
